import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import { PRODUCT_SUBTYPES } from "shared/payment/constants";
import SanitizedText from "shared/components/SanitizedText";
import WashingtonStateTaxDisclaimer from "apps/payment/components/WashingtonStateTaxDisclaimer";
import _str from "shared/util/_str";

import "./ProductInfo.scss";

const PRODUCT_SUBTYPE_TO_PRICE_MAP = {
	ALIST: _str("Month"),
	INCOGNITO: _str("Month"),
	ALISTPREMIUM: _str("Month"),
	BOOST: _str("each"),
	READ_RECEIPT: _str("each"),
};

const ProductInfo = ({
	productName,
	taxAmount,
	productPrice,
	productSubtype,
	totalPrice,
	hasVATIncluded,
	isInternational,
	convertedProductPrice,
	isUserInWashingtonState,
}) => {
	const formattedProductSubtypeToPrice = `/ ${PRODUCT_SUBTYPE_TO_PRICE_MAP[productSubtype]}`;

	return (
		<React.Fragment>
			<div
				className="product-info"
			>
				<div className="product-info-left-column">
					<div className="product-info-product-name">
						{productName}
					</div>
					{!isInternational
						&& (
							<div className="product-info-tax">
								<Str>
									Tax
								</Str>
							</div>
						)
					}
					<div className="product-info-total">
						<Str>
							Total
						</Str>
						{hasVATIncluded && <Str className="product-info-total-vat">&nbsp;(VAT included)</Str>}
					</div>
				</div>
				<div className="product-info-right-column">
					<div>
						{productPrice}
						{!!PRODUCT_SUBTYPE_TO_PRICE_MAP[productSubtype]
							&& formattedProductSubtypeToPrice
						}
					</div>
					{!isInternational
						&& (
							<div className="product-info-tax">
								{taxAmount || "$0.00"}
							</div>
						)
					}
					<div className="product-info-total">
						{totalPrice}
					</div>
				</div>
				{isInternational
				&& (
					<div className="product-info-converted-price">
						<Str>Charged as&nbsp;</Str>
						<SanitizedText
							Element="span"
							text={convertedProductPrice}
							shouldDangerouslySetInnerHTML
						/>
					</div>
				)
				}
			</div>
			{
				isUserInWashingtonState &&
				<WashingtonStateTaxDisclaimer />
			}
		</React.Fragment>
	);
};

ProductInfo.propTypes = {
	productName: PropTypes.string.isRequired,
	taxAmount: PropTypes.string,
	productPrice: PropTypes.string.isRequired,
	productSubtype: PropTypes.oneOf(Object.values(PRODUCT_SUBTYPES)).isRequired,
	totalPrice: PropTypes.string.isRequired,
	hasVATIncluded: PropTypes.bool,
	isInternational: PropTypes.bool,
	convertedProductPrice: PropTypes.string,
	isUserInWashingtonState: PropTypes.bool,
};

ProductInfo.defaultProps = {
	hasVATIncluded: false,
	isInternational: false,
	convertedProductPrice: null,
	taxAmount: "$0.00",
	isUserInWashingtonState: false,
};

export default ProductInfo;



// WEBPACK FOOTER //
// ./src/apps/payment/components/ProductInfo/ProductInfo.jsx